import { Component } from '@verndale/core';
import YouTubeIframeLoader from 'youtube-iframe';
import MicroModal from 'micromodal';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      iframe: this.el.querySelector('.iframe'),
      videoContainer: this.el.parentNode.querySelector('.media-image-card__image .media-image-card__video-container'),
      openModal: document.querySelector('modal micromodal-slide is-open'),
    };

    this.src = this.el.dataset.url;
    this.autoPlay = this.el.dataset.modalAutoplay;

    if (this.dom.iframe) {
      YouTubeIframeLoader.load(this.handleIframeLoader.bind(this));
    }

    this.initMicroModal();
  }

  addListeners() {}

  handleVideoStop() {
    this.player.pauseVideo();
  }

  initMicroModal() {
    MicroModal.init({
      openTrigger: 'data-custom-open',
      closeTrigger: 'data-custom-close',
      disableScroll: true,
      disableFocus: false,
      awaitCloseAnimation: true,
      awaitOpenAnimation: true,
      onShow: () => {
        if (this.autoPlay && this.player.playVideo && this.el.classList.contains('is-open')) {
          this.player.playVideo();
        }
      },
      onClose: () => {
        if (this.player.playVideo) {
          this.handleVideoStop();
        }
      }
    });
  }

  handleIframeLoader(YT) {
    this.config = {
      modestbranding: 1,
      rel: 0,
      showinfo: 0,
      autohide: 1,
      playsinline: 1,
      controls: 1,
    };
    
    this.playerId = this.src;

    this.player = new YT.Player(this.dom.iframe, {
      height: '488',
      width: '868',
      videoId: this.src,
      playerVars: this.config
    });
  }
}

export default Module;
